import React from 'react';
import { CheckCircle, AlertTriangle, Info, X } from 'lucide-react';
import { Button } from '../Button/Button';
import type { Toast as ToastType } from '../../../contexts/ToastContext';

interface ToastProps {
  toast: ToastType;
  onClose: () => void;
}

export const Toast: React.FC<ToastProps> = ({ toast, onClose }) => {
  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return <CheckCircle size={20} />;
      case 'error':
        return <AlertTriangle size={20} />;
      case 'info':
        return <Info size={20} />;
      default:
        return <Info size={20} />;
    }
  };

  return (
    <div className={`toast toast--${toast.type}`} role="alert">
      <div className="toast__icon">
        {getIcon()}
      </div>
      <div className="toast__content">
        <p>{toast.message}</p>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onClose}
        aria-label="閉じる"
        className="toast__close"
      >
        <X size={16} />
      </Button>
    </div>
  );
};